/*
 * @Author: your name
 * @Date: 2020-06-05 11:35:44
 * @LastEditTime: 2020-08-13 18:40:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /LonBonStore/src/components/customerService/messageWithdrawal.js
 */
var messageWithdrawalJS = {
    data() {
        return {
            timer: null, // 定时器
            startTime: 0, // 行为起始时间
            endTime: 0, // 行为结束时间
            messageWithdrawalIndex: '', // 当前撤回消息的index
            messageWithdrawalEntity: '' // 当前撤回消息实体
        }
    },
    computed: {
        wsdata() {
            return this.$store.state.wsdata;
        }
    },
    watch: {
        //监听点击事件
        // messageWithdrawalIndex(value) {
        //     if (value) {
        //         document.body.addEventListener('click', this.closeMenu);
        //     } else {
        //         document.body.removeEventListener('click', this.closeMenu);
        //     }
        // },
        wsdata(obj) { }
    },
    methods: {
        //  长按消息开始
        longPressMessageStart(mesaageItem_, index_) {
            console.log('长按消息开始');
            this.startTime = Date.now(); //获取行为开始时间
            let that = this;
            that.timer = setTimeout(() => {
                //执行删除逻辑
                // that.deleteMessage(mesaageItem_, index_)
                that.msgList[index_].isOptionsShow = true
                for (let index = 0; index < that.msgList.length; index++) {
                    if (index != index_) {
                        that.msgList[index].isOptionsShow = false;
                    }
                }
            }, 500) // 假设长按时间为500毫秒
        },
        // 长按消息移动
        longPressMessageMove() {
            console.log('长按消息移动');
        },
        // 长按消息结束
        longPressMessageEnd() {
            console.log('长按消息结束');
            this.endTime = Date.now(); //获取行为结束时间
            clearTimeout(this.timer); //清除定时器，此时阻止了删除逻辑的触发
            if (this.endTime - this.startTime < 500) { //如果行为时常小于长按，则执行编辑逻辑
                //执行编辑逻辑
            }
        },
        // 删除消息记录
        deleteMessage() {
            let that = this;
            //   that.$vux.loading.show();
            if (that.msgList[that.messageWithdrawalIndex].messageStatus == 0) {
                console.log('消息主键' + that.messageWithdrawalEntity.customerServiceConsultId);
                var data = {
                    customerServiceConsultId: that.messageWithdrawalEntity.customerServiceConsultId // 消息主键
                };
                that.$axios.post('/api/v1.0/lonbonShop/revocation', that.qs.stringify(data))
                    .then(function (res) {
                        if (res.status == 200) {
                            // that.$vux.loading.hide();
                            console.log('删除消息成功');
                            that.$vux.toast.text(res.msg)
                            that.msgList[that.messageWithdrawalIndex].messageStatus = 1;
                            that.msgList[that.messageWithdrawalIndex].isOptionsShow = false;
                            that.popConfirmMenus = false;
                        }
                    })
                    .catch(function () {
                        console.log('删除消息失败');
                        that.msgList[that.messageWithdrawalIndex].isOptionsShow = false;
                        that.popConfirmMenus = false;
                        //   that.$vux.loading.hide();
                    });
            }
        },
        // 撤回消息
        cancleOrderFunc(entity_, index_) {
            this.messageWithdrawalIndex = index_;
            this.messageWithdrawalEntity = entity_;
            this.msgList[index_].isOptionsShow = false;
            let that = this;
            that.$vux.confirm.show({
                content: `确定要撤回该条消息吗？`,
                cancelText: '取消',
                confirmText: '确定',
                title: '提示',
                onConfirm() {
                    that.deleteMessage();
                }
            })
        },
        closeMenu() {
            for (let index = 0; index < this.msgList.length; index++) {
                this.msgList[index].isOptionsShow = false;
            }
        },
        /**
         * @description: 弹起确认框
         */
        showConfirmAction(entity_, index_) {
            this.messageWithdrawalIndex = index_;
            this.messageWithdrawalEntity = entity_;
            this.msgList[index_].isOptionsShow = false;
            this.popConfirmMenus = true;
        },
        /**
         * @description: 菜单项列表 触发事件
         * @param {type}  menuKey  未知   
         * @param {object}  menuKey  选项列表
         */
        checkType(menuKey, menuItem) {
            if (menuKey == 'cancel') {
            } else {
                if (menuItem.type == 6) {
                    this.deleteMessage();
                }
            }
        }
    },
    mounted() { 
    }
}
export default messageWithdrawalJS = messageWithdrawalJS



// WEBPACK FOOTER //
// ./src/pcComponents/customerService/messageWithdrawal.js